import { useEffect, useState } from 'react';
import apiService from '../services/api';

// One Dream summary read shared by every block on a page. Mounts that overlap
// share the in-flight request, and a read that just finished is reused for a
// few seconds so a page of merchant badges does not fetch once per card.
const CACHE_MS = 15000;
let cache = { at: 0, data: null, promise: null };

export function clearDreamSummaryCache() {
  cache = { at: 0, data: null, promise: null };
}

export function readDreamSummary() {
  const now = Date.now();
  if (cache.data && now - cache.at < CACHE_MS) return Promise.resolve(cache.data);
  if (cache.promise) return cache.promise;
  let request;
  try {
    request = Promise.resolve(apiService.getDreamSummary());
  } catch (err) {
    request = Promise.reject(err);
  }
  cache.promise = request
    .then((data) => {
      cache = { at: Date.now(), data, promise: null };
      return data;
    })
    .catch((err) => {
      cache.promise = null;
      throw err;
    });
  return cache.promise;
}

/** The summary once it arrives, null before that and when the read fails. */
export default function useDreamSummary(reloadKey = 0) {
  const [summary, setSummary] = useState(() => (Date.now() - cache.at < CACHE_MS ? cache.data : null));

  useEffect(() => {
    let cancelled = false;
    if (reloadKey) clearDreamSummaryCache();
    readDreamSummary()
      .then((data) => {
        if (!cancelled) setSummary(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [reloadKey]);

  return summary;
}
